// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowDown: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M10.869.5h-1c-.27 0-.522.101-.683.272L5.968 4.2a.381.381 0 01-.524 0L2.226.772A.941.941 0 001.543.5h-1C.265.5.107.752.272.928l5.11 5.444c.162.17.484.17.644 0l5.11-5.443C11.305.752 11.147.5 10.87.5"
            />
        </svg>
    );
};

export default React.memo(ArrowDown);
